<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns" v-show="isEmployeesVisible">
        <div class="column has-text-centered"><label>Zaposleni:</label></div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :disabled="isEmployeesDisabled"
            :clearable="false"
            :options="employees"
            v-model="selectedEmployee"
          />
        </div>
      </div>
      <!-- Status -->
      <div class="columns" v-show="isStatusesVisible">
        <div class="column has-text-centered"><label>Status:</label></div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="listboxStatuses"
            v-model="selecteListboxdStatus"
          />
        </div>
      </div>
      <!-- opis -->
      <div class="columns">
        <div class="column">
          <input
            class="input has-text-centered has-background-info-light"
            ref="description"
            type="text"
            placeholder="opis"
            v-model="selectedItem.note"
          />
        </div>
      </div>
      <!-- Startno i završno vrijeme -->
      <div class="columns" v-show="isDatesVisible">
        <!-- Startno vrijeme -->
        <div class="column">
          <date-picker
            v-model="startDate"
            type="date"
            placeholder="Početak"
          ></date-picker>
        </div>
        <!-- Završno vrijeme -->
        <div class="column">
          <date-picker
            v-model="endDate"
            type="date"
            placeholder="Kraj"
          ></date-picker>
        </div>
      </div>
      <!-- preview -->
      <div class="columns">
        <div class="column">
          <span v-html="previewNote"></span>
        </div>
      </div>
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
            :disabled="isSaveAndCloseButtonDisabled"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "EditAbsence",

  components: {
    DatePicker,
  },

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedItem: Object,
    selectedDailyLog: Object,
    selectedStatusId: Number,
    statuses: Array,
    isStatusesVisible: Boolean,
    employees: Array,
    isEmployeesVisible: Boolean,
    departments: Array,
    isDatesVisible: Boolean,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      //   selectedItem: null,
      listboxStatuses: [],
      selecteListboxdStatus: null,
      selectedEmployee: null,
      startDate: null,
      endDate: null,
      isEmployeesDisabled: false,
    };
  },
  computed: {
    previewNote() {
      if (this.selectedEmployee != null) {
        return (
          "<p><b>" +
          this.selectedEmployee.name +
          " " +
          this.selectedEmployee.departmentName +
          "</b> - " +
          this.selectedItem.note +
          "</p>"
        );
      } else return "<p>" + this.selectedItem.note + "</p>";
    },
    isSaveAndCloseButtonDisabled() {
      // // evaluate whatever you need to determine disabled here...
      // if (this.selectedEmployee && this.selecteListboxdStatus) {
      //   return false;
      // }
      // else return true;
      return false;
    },
  },
  mounted() {
    console.log("mounted");
    console.log(this.selectedItem);
    // selected item
    if (this.selectedItem.employeeId !== null) {
      console.log(this.departments);
      console.log(this.employees);
      this.isEmployeesDisabled = true;
      this.selectedEmployee = {
        id: this.selectedItem.employeeId,
        name: this.employeeFromId(this.selectedItem.employeeId).name,
        departmentName: this.employeeFromId(this.selectedItem.employeeId)
          .departmentName,
      };
    }

    // selected company id
    this.selectedItem.companyId = this.$store.state.general.companyId;

    // selected status
    console.log("HIC 55");
    this.arrangeStatuses();

    console.log("HIC 122");
    console.log(this.selectedStatusId);
    console.log(this.statuses);
    if (this.selectedStatusId !== null) {
      this.selecteListboxdStatus = this.listboxStatuses.find(
        (lbs) => lbs.id === this.selectedStatusId
      );
    }
    console.log(this.selecteListboxdStatus);

    // console.log(this.selectedDailyLog);

    // this.selecteListboxdStatus = this.listboxStatuses.find(
    //   (x) => x.id === this.selectedDailyLog.statusId
    // );
    // console.log(this.selecteListboxdStatus);

    // if (this.selectedDailyLog != null) {
    //   console.log("HIC 56");
    //   console.log(this.statuses);
    //   this.selecteListboxdStatus = this.listboxStatuses.find(
    //     (x) => x.id === this.selectedDailyLog.statusId
    //   );
    //   console.log(this.selecteListboxdStatus);
    // }
  },
  updated() {
    this.focusInput();
  },
  methods: {
    saveAndProceedButtonClicked() {
      this.calculateEmployee();
      this.$emit("saveAndProceedClicked", this.selectedItem);
      console.log(this.selectedItem);
    },
    saveAndCloseButtonClicked() {
      this.calculateEmployee();
      this.$emit("saveAndCloseClicked", this.selectedItem);
      console.log(this.selectedItem);
    },
    focusInput() {
      this.$refs["description"].focus();
    },
    employeeFromId(id) {
      return this.employees.find((x) => x.id === id);
    },
    arrangeStatuses() {
      this.statuses.forEach((sts) => {
        this.listboxStatuses.push({
          id: sts.statusId,
          name: sts.code + sts.description,
        });
      });
    },
    calculateEmployee() {
      console.log("xxSelectedStatusxx");
      console.log(this.selecteListboxdStatus);
      if (this.selecteListboxdStatus) {
        this.selectedItem.statusId = this.selecteListboxdStatus.id;
      }
      // if (this.startDate && this.endDate) {
      //   this.selectedItem.startDate = this.startDate
      //     .toISOString()
      //     .split("T")[0];
      //   this.selectedItem.endDate = this.endDate.toISOString().split("T")[0];
      // }
      if (this.isEmployeesVisible !== false) {
        this.selectedItem.boldText =
          this.selectedEmployee.name +
          " " +
          this.selectedEmployee.departmentName +
          " - ";

        this.selectedItem.employeeId = this.selectedEmployee.id;
      }
      this.selectedItem.previewNote = this.previewNote;
    },
  },
};
</script>
